const INITIAL_STATE = {
  data: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SIGN_UP_SUCCESS":
      return { ...state, data: action.payload };

    case "SIGN_UP_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
